var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtmosphereQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 28,
    viewBox: "0 0 47 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 27.6H0.8L12 0.799998H23.5L18.3 27.6ZM41 27.6H23.6L34.8 0.799998H46.2L41 27.6Z",
    fill: "#6E9A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmosphereQuotes);
export default __webpack_public_path__ + "static/media/atmosphere-quotes.ab0492b73f3987c75405913091595a5c.svg";
export { ForwardRef as ReactComponent };